import WithRender from "../../templates/tables/otherOptionsTable.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getIsCimpressProduct"]),
    name: () => {
      return "Others";
    }
  }
});
